import {
    Avatar,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { isEmpty, map } from 'lodash'
import { USER_REFERRAL } from '../../../../api/endpoints.constants'
import { getUserRefferals } from '../../../../api/userReferral'
import { CoinLabel } from '../../../../components/CoinLabel'
import { theme } from '../../../../theme'
import { TableColumn } from '../../FinancesPage/components/billing/BillingTableHeading'
import { MainColumn } from '../../FinancesPage/components/billing/MainColumn'
import PersonIcon from './../../../../assets/icons/Person.svg?react'

const columns: TableColumn[] = [
    { id: 'user', label: 'Пользователь', maxWidth: 200, align: 'left' },
    { id: 'amount', label: 'Начислено', maxWidth: 200 },
    { id: 'bonus_amount', label: 'Заработано', maxWidth: 200, align: 'right' },
]

const ReferralTable = () => {
    const { data: referrals } = useQuery({
        queryKey: [USER_REFERRAL],
        queryFn: () => getUserRefferals(),
    })

    const tableHeading = (
        <TableHead>
            <TableRow>
                {columns.map((column, index) => (
                    <TableCell
                        align={column.align}
                        sx={{
                            background: '#F5F5F5',
                        }}
                        key={column.id}
                        style={{
                            maxWidth: column.maxWidth,
                            borderTopLeftRadius: index === 0 ? '16px' : 0,
                            borderTopRightRadius: index === columns.length - 1 ? '16px' : 0,
                        }}>
                        {column.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )

    const rows = map(referrals, ({ bonus_amount, amount, email, profile_pic }) => (
        <TableRow hover key={email}>
            <MainColumn align="left">
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        [theme.breakpoints.down('md')]: {
                            flexDirection: 'column',
                        },
                    }}>
                    <Avatar
                        sx={{
                            backgroundColor: '#F9FAFB',
                        }}
                        src={profile_pic ?? ''}>
                        <PersonIcon color="#5A5F72" />
                    </Avatar>
                    <Typography
                        variant="body2"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            [theme.breakpoints.down('sm')]: {
                                maxWidth: '80px',
                            },
                        }}>
                        {email}
                    </Typography>
                </Box>
            </MainColumn>
            <TableCell>
                <Typography
                    variant="body2"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                        [theme.breakpoints.down('sm')]: {
                            maxWidth: '70px',
                        },
                    }}>
                    <CoinLabel coin={amount} />
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Typography
                    variant="body2"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                        color: '#019555',
                        [theme.breakpoints.down('sm')]: {
                            maxWidth: '70px',
                        },
                    }}>
                    +<CoinLabel coin={bonus_amount} />
                </Typography>
            </TableCell>
        </TableRow>
    ))

    if (isEmpty(referrals)) {
        return null
    }

    return (
        <Table stickyHeader aria-label="sticky table">
            {tableHeading}
            <TableBody>{rows}</TableBody>
        </Table>
    )
}

export default ReferralTable
